import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	routes,
	mode: 'hash'
})

router.beforeEach(async (to, from, next) => {
	let is_login = store.getters.is_login;
	const notList = [
		'404',
		// 'forget',
		// 'steps',
		// 'index',
	];
	if (is_login) {
		if (to.path === '/login') {
			next({
				path: '/map'
			})
		} else {
			next();
		}
		next();
	} else {
		if (notList.indexOf(to.name) === -1) {
			next(to.path !== '/login' ? {
				path: '/login'
			} : true);
		} else {
			next();
		}
	}
})

export default router